export default __webpack_public_path__ + "static/media/irActive.5027d9b9.svg";